module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE STORY DEVOTIONAL")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct1p",
    attrs: {
      "id": "p0023-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#fn_16",
      "id": "sn_16"
    }
  }, [_vm._v("DAY 16")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fn_16"
    }
  }, [_vm._v("HEARTBROKEN YET FAITHFUL")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('span', [_c('i', [_vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" saw how great the wickedness of the human race had become on earth, and that every inclination of the thoughts of the human heart was only evil all the time. The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" regretted that he had made human beings on the earth, and his heart was deeply troubled.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("GENESIS ")]), _vm._v("6:5–6")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0023-04-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("R")]), _vm._v("egret is a heavy burden. We can never rewind the clock. Often we can do absolutely nothing to make right what is wrong, to unsay or undo those things that hurt someone we love.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But when God experienced regret “that he had made human beings,” he announced a plan of action. Radical action. As in “wipe from the face of the earth the human race I have created” as well as the animals, birds, and other creatures he had delighted in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But more significant than his action—an act he promised to never again do—is his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sinful human beings did not choose to love him and live according to his ways, and he was “deeply troubled.” God’s heart will always break when people—when you—turn away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yet God responded to the faithfulness he did find: he spared Noah and his family from the destruction to come. God will always notice, acknowledge, and honor your faithfulness to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx3"
  }, [_vm._v("THE FAITHFULNESS OF ONE SHINES BRIGHTLY IN THE WORLD’S DARKNESS.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b65fc79a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter19.vue
// module id = 117
// module chunks = 0